<template>
  <div v-if="typesStatus.isLoading" class="loader center-middle">
    <LoadingState :size="50" />
  </div>
  <div v-else-if="typesStatus.isErrored">
    <ErrorState />
  </div>
  <form v-else @submit.prevent="submit">
    <!-- select what type of rabbitmq container you want (small, medium, large, etc) -->
    <FormContainerTypeSelect v-model="fields.typeId" :types="types" />

    <div class="form-buttons">
      <Btn
        class="mr-2"
        variant="light"
        type="button"
        :disabled="loading"
        @click="cancel"
        data-test="cancel-enable-rabbitmq-button"
      >
        {{ $t("global.cancel") }}
      </Btn>
      <Btn
        variant="primary"
        type="submit"
        :disabled="!isSubmittable()"
        :loading="loading"
        data-test="enable-rabbitmq-button"
      >
        {{ $t("global.enable") }}
      </Btn>
    </div>
  </form>
</template>

<script>
import { computed, reactive, ref } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import ErrorState from "@/components/display/ErrorState";
import FormContainerTypeSelect from "@/components/display/form/FormContainerTypeSelect";
import LoadingState from "@/components/display/LoadingState";
import store from "@/store";
import useValidator from "@/utils/useValidator";
import { enableElasticsearch as validationRules } from "leatherman-js/utils/validations/forms";

export default {
  name: "RabbitMQResizeForm",
  components: {
    Btn,
    ErrorState,
    FormContainerTypeSelect,
    LoadingState,
  },
  props: {
    site: {
      type: Object,
      required: true,
    },
    container: Object,
  },
  setup(props, { emit, root }) {
    const errors = ref(null);
    const loading = ref(false);
    const types = computed(() => store.getters["containers/getRabbitMQTypes"]);
    const typesStatus = computed(() => store.getters["containers/getTypesStatus"]);

    // default select the first version in the list
    const fields = reactive({
      typeId: props.container.typeId,
    });
    const { validator } = useValidator();
    const validation = validator(
      fields,
      validationRules,
      {},
      {
        typeId: {
          required: root.$t("validation.container-type-required"),
        },
      }
    );

    const cancel = () => emit("cancel");

    const submit = () => {
      errors.value = null;

      validation.reset();
      validation.validate().then(() => {
        loading.value = true;

        const data = {
          addonId: fields.typeId,
          groupId: props.container.id,
        };
        store
          .dispatch("containers/resize", { id: props.site.id, data })
          .then(() => {
            store.dispatch("toasts/addToast", {
              variant: "info",
              message: root.$t("toasts.rabbitmq-resizing-message", {
                name: props.site.domain,
              }),
            });
            emit("success");
          })
          .catch(() => {
            store.dispatch("toasts/addToast", {
              variant: "info",
              message: root.$t("toasts.rabbitmq-resizing-error-message", {
                name: props.site.domain,
              }),
            });
          })
          .finally(() => {
            loading.value = false;
          });
      });
    };

    const isSubmittable = () => !!fields.typeId && fields.typeId !== props.container.typeId;

    return {
      errors,
      loading,
      fields,
      submit,
      validation,
      cancel,
      types,
      typesStatus,
      isSubmittable,
    };
  },
};
</script>

<style lang="scss" scoped></style>
